
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widerrufsrecht/bfit",
      function () {
        return require("private-next-pages/widerrufsrecht/bfit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widerrufsrecht/bfit"])
      });
    }
  